export const COLUMN_ID = 'applicationId';
export const COLUMN_APPLICATION = 'applicationName';
export const COLUMN_LAST_UPDATED = 'updatedDate';
export const COLUMN_LAST_UPDATED_BY = 'updatedBy';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED = 'createdDate';
export const ACTION_DOWNLOAD = 'download';
